import { Typography, Button, Row, Box } from '@vp/swan'
import { useTranslation } from 'react-i18next'
// Components
import styles, { stylesheet } from './Email.scss'
import { AssetStoreProvider } from '../../contexts/AssetStoreProvider'
import { useStyles } from '@vp/ubik-context'
// Services

interface Props {
  locale: string
  tenant: string
}
export const DisabledEmail = (props: Props) => {
  const { locale, tenant } = props
  const { t } = useTranslation(tenant)
  const lng = locale.toLowerCase().replace('-', '_')
  useStyles(stylesheet)
  return (
    <Box className={styles.emailFormContainer}>
      <AssetStoreProvider>
        <Box paddingRight="2" className={styles.contentContainer}>
          <Row>
            <div style={{ display: 'flex' }}>
              <Typography component="h3" fontSize="x2large">
                {t(`${tenant}:email.title`, { lng })}
              </Typography>
            </div>
          </Row>
          <Row pt="5">
            <Typography component="span" fontSize="standard" ml="3" style={{ display: 'block' }}>
              {t(`${tenant}:email.service_unavailable`, { lng })}
            </Typography>
          </Row>
          <Row pt="5">
            <Button disabled style={{ cursor: 'pointer' }} skin="primary" type="button" name="show_email_form" value="show_email_form">
              {t(`${tenant}:email.buttons.send_email.title`, { lng })}
            </Button>
          </Row>
        </Box>
      </AssetStoreProvider>
    </Box>
  )
}
